//
export default props => [
    {
        text: 'código proveedor',
        value: 'provider_product_code',
        width: '10%',
    },
    {
        text: 'código interno',
        value: 'wh_product_internal_code',
        width: '10%',
    },
    {
        text: 'nombre',
        value: props.is_service ? 'wh_product_service_name' : 'wh_product_name',
        component: props.is_service ? undefined : {
            custom: 'wh_product_id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'product-update',
                        params: {
                            id: value,
                        },
                    }),
                tooltip: 'Detalle del producto',
            },
        },
    },
    {
        text: 'estado',
        value: 'status',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                palette: {
                    recepcionado: 'success lighten-3',
                    recepción_parcial: 'info lighten-3',
                },
                noEvents: true,
                small: true,
            },
        },
        width: '10%',
    },
    {
        text: 'solicitado',
        value: 'quantity',
        align: 'right',
        format: 'number',
        width: '10%',
    },
    {
        text: 'recepcionado',
        value: 'received',
        align: 'right',
        format: 'number',
        width: '10%',
    },
    {
        text: 'restante',
        value: 'remnant',
        align: 'right',
        format: 'number',
        width: '10%',
    },
]
